export enum DataExchangeStatus {
    Unknown = 'Unknown',
    Pending = 'Pending',
    OK = 'OK',
    Error = 'Error',
    Warning = 'Warning'
}
